import React, { useState } from "react";
import { Canvas } from "@react-three/fiber";
import { EffectComposer, Bloom, GodRays } from "@react-three/postprocessing";
import BlackHolev2 from "./BlackHolev2";
import AkrecniDisk from "./AkrecniDisk";
import NameText from "./NameText";
import Stars from "./Stars";
import GalacticDust from "./GalacticDust";
import Meteors from "./Meteors";
import RingedStars from "./RingedStars";
import SuperBrightStars from "./SuperBrightStars";
import CameraController from "./CameraController";
import PerformanceMonitor from "./PerformanceMonitor";


function App() {
  const [brightStars, setBrightStars] = useState([]);

  return (
    <Canvas
      camera={{ position: [0, 0, 30], fov: 75, near: 0.1, far: 5000 }}
      style={{ width: "100vw", height: "100vh" }}
      gl={{ physicallyCorrectLights: true, toneMappingExposure: 0.6, toneMapping: 2 }}
    >
      <color attach="background" args={["black"]} />

      {/* 🌟 SVĚTLA */}
      <ambientLight intensity={0.01} color="white" />

      {/* 🌠 Vesmírné objekty */}
      <Stars />
      <SuperBrightStars setBrightStars={setBrightStars} />
      <RingedStars />
      <GalacticDust />
      <BlackHolev2 /> {/* 🕳 Zrcadlová koule */}
      <AkrecniDisk /> {/* 🌌 Akreční disk */}
      <NameText />
      <Meteors />

      {/* ✨ Post-processing efekty */}
      <EffectComposer>
        <Bloom intensity={1.0} luminanceThreshold={0.08} luminanceSmoothing={0.93} />
        {brightStars.filter(Boolean).map((star, index) => (
          <GodRays key={index} sun={star} intensity={0.29} decay={0.91} />
        ))}
      </EffectComposer>

      <CameraController />
      <PerformanceMonitor />
    </Canvas>
  );
}

export default App;